import React, { Fragment } from 'react';
  
  const ContactUs = ({
    isMobile
  }) =>  {
    return (
        <Fragment>
              
            {/* Heading */}
            <div style={{paddingBottom: '2rem', marginBottom: '2rem', borderBottom: '1px solid rgb(39,39,42)'}}>
                <h1 style={{fontWeight: 'bold', fontSize: '1.5rem', margin: 0}}>
                        Contact Us
                </h1>
                <p style={{color: 'rgb(161,161,170)', fontSize: '.875rem', marginTop: '.5rem'}}>
                    Get in touch with our support team.
                </p>
            </div>
            {/* Main content */}
            <div>
                {/* Box Section */}
                <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Customer Service
                    </h2>
                    <div style={{height: '1.5rem'}}></div>
                    <h2 style={{color: 'rgb(228,228,231)', fontWeight: 500, fontSize: '1rem', margin: 0}}>
                        Email
                    </h2>
                    <p style={{color: '#fff)', fontWeight: 500, fontSize: '1.125rem', lineHeight: '1.75rem', margin: '.5rem 0'}}>
                        support@interviewcheater.com
                    </p>
                </div>
            </div>
        </Fragment>
    );
  }
  
  export default ContactUs;
  